/**
 * Combine all reducers in this file and export the combined reducers.
 */
import produce from 'immer';
import { combineReducers } from 'redux-immer';
import { routerReducer } from 'react-router-redux';
import authorizationReducer from 'containers/Authorization/reducer';
import photoSessionsReducer from 'containers/PhotoSessions/reducer';
import photoSessionDetailReducer from 'containers/PhotoSessionDetail/reducer';
import checklistReducer from 'containers/Checklist/reducer';
import issueReportReducer from 'containers/IssueReport/reducer';
import photosManagerReducer from 'containers/PhotosManager/reducer';
import videoReducer from 'containers/Video/reducer';
import announcementStepsReducer from 'containers/AnnouncementSteps/reducer';
import profileReducer from 'containers/Profile/reducer';
import propertyAssessmentReducer from 'containers/PropertyAssessment/reducer';
import paymentsReducer from 'containers/Payments/reducer';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

const createReducer = (injectedReducers = {}) => combineReducers(produce, {
  authorization: authorizationReducer,
  photoSessions: photoSessionsReducer,
  photoSessionDetail: photoSessionDetailReducer,
  checklist: checklistReducer,
  issueReport: issueReportReducer,
  photo: photosManagerReducer,
  video: videoReducer,
  announcementSteps: announcementStepsReducer,
  profile: profileReducer,
  routing: routerReducer,
  propertyAssessment: propertyAssessmentReducer,
  payments: paymentsReducer,
  ...injectedReducers,
});

export default createReducer;
